export default {
  "footer": {
    "address": "Endereço",
    "visit_us": "Venha nos visitar:",
    "contact": "Contato",
    "contact_description": "Saiba mais, entre em contato conosco:",
    "support": "Apoio",
    "email": "E-mail",
    "phone": "Telefone",
    "social_media": "Siga-nos nas redes sociais:",
    "copyright": "Todos direitos reservados.",
    "innovation_city":"(Cidade da Inovação)"
  }
}
